export { default } from './CheckboxField';



// WEBPACK FOOTER //
// ./app/components/shared/Facets/CheckboxField/index.js